<template>
  <div class="container">
    <div class="top">
      <span class="left">
        <button @click="getData">데이터 추출</button>
      </span>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">HEADER</span>
        <hr />
      </div>
      <div class="left-right-container">
        <div class="left-right">
          <span class="left"> 헤더이미지 </span>
          <b-form-input autocomplete="off" class="right" :value="data.header.url" />
        </div>
        <div class="left-right">
          <span class="left"> 헤더타이틀 </span>
          <b-form-input autocomplete="off" class="right" :value="data.header.title" />
        </div>
        <div class="left-right">
          <span class="left"> 헤더설명 </span>
          <b-form-input autocomplete="off" class="right" :value="data.header.desc" />
        </div>
        <div class="left-right">
          <span class="left"> 헤더가격 </span>
          <b-form-input autocomplete="off" class="right" :value="data.header.price" />
        </div>
      </div>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">공지사항</span>
        <button @click="addText(data.notice)">줄 추가</button>
        <button @click="removeText(data.notice)">줄 삭제</button>
        <hr />
      </div>
      <div class="left-right-container">
        <div class="left-right" v-for="(n, index) in data.notice" :key="index">
          <span class="left"> </span>
          <b-form-input autocomplete="off" class="right" :value="n" />
        </div>
      </div>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">멤버십</span>
        <button @click="addText(data.membership)">줄 추가</button>
        <button @click="removeText(data.membership)">줄 삭제</button>
      </div>
      <div class="left-right-container">
        <div class="left-right" v-for="(n, index) in data.membership" :key="index">
          <span class="left"> </span>
          <b-form-input autocomplete="off" class="right" :value="n" />
        </div>
      </div>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">ROOM</span>
        <button @click="addItem(data.rooms)">아이템 추가</button>
        <button @click="removeItem(data.rooms)">아이템 삭제</button>
      </div>
      <hr />
      <div class="left-right-container" v-for="(n, index) in data.rooms" :key="index">
        <div class="left-right">
          <span class="left"> 이미지 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="img" v-for="(img, index) in n.images" :key="index" />
          </div>

          <div class="left">
            <button @click="addText(n.images)">이미지추가</button>
            <button @click="removeText(n.images)">이미지삭제</button>
          </div>
        </div>
        <div class="left-right">
          <span class="left"> 서브타이틀(우측) </span>
          <b-form-input autocomplete="off" class="right" :value="n.subtitle" />
        </div>
        <div class="left-right">
          <span class="left"> 설명 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="img" v-for="(img, index) in n.desc" :key="index" />
          </div>
          <div class="left">
            <button @click="addText(n.desc)">텍스트 추가</button>
            <button @click="removeText(n.desc)">텍스트 삭제</button>
          </div>
        </div>
      </div>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">PACKAGE SPECIAL</span>
        <button @click="addItem(data.rooms)">아이템 추가</button>
        <button @click="removeItem(data.rooms)">아이템 삭제</button>
      </div>
      <hr />
      <div class="left-right-container" v-for="(n, index) in data.packages" :key="index">
        <div class="left-right">
          <span class="left"> 이미지 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="img" v-for="(img, index) in n.images" :key="index" />
          </div>

          <div class="left">
            <button @click="addText(n.images)">이미지추가</button>
            <button @click="removeText(n.images)">이미지삭제</button>
          </div>
        </div>
        <div class="left-right">
          <span class="left"> 서브타이틀(우측) </span>
          <b-form-input autocomplete="off" class="right" :value="n.subtitle" />
        </div>
        <div class="left-right">
          <span class="left"> 설명 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="img" v-for="(img, index) in n.desc" :key="index" />
          </div>
          <div class="left">
            <button @click="addText(n.desc)">텍스트 추가</button>
            <button @click="removeText(n.desc)">텍스트 삭제</button>
          </div>
        </div>
      </div>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">포함사항</span>
        <button @click="addItem(data.rooms)">아이템 추가</button>
        <button @click="removeItem(data.rooms)">아이템 삭제</button>
      </div>
      <hr />
      <div class="left-right-container" v-for="(n, index) in data.includes" :key="index">
        <div class="left-right">
          <span class="left"> 이미지 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="img" v-for="(img, index) in n.images" :key="index" />
          </div>

          <div class="left">
            <button @click="addText(n.images)">이미지추가</button>
            <button @click="removeText(n.images)">이미지삭제</button>
          </div>
        </div>
        <div class="left-right">
          <span class="left"> 서브타이틀(우측) </span>
          <b-form-input autocomplete="off" class="right" :value="n.subtitle" />
        </div>
        <div class="left-right">
          <span class="left"> 설명 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="img" v-for="(img, index) in n.desc" :key="index" />
          </div>
          <div class="left">
            <button @click="addText(n.desc)">텍스트 추가</button>
            <button @click="removeText(n.desc)">텍스트 삭제</button>
          </div>
        </div>
      </div>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">OPTIONS</span>
        <button @click="addItem(data.rooms)">아이템 추가</button>
        <button @click="removeItem(data.rooms)">아이템 삭제</button>
      </div>
      <hr />
      <div class="left-right-container">
        <div class="left-right">
          <span class="left"> 옵션 상단설명 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="n" v-for="(n, index) in data.optiondesc" :key="index" />
          </div>
          <div class="left">
            <button @click="addText(data.optiondesc)">추가</button>
            <button @click="removeText(data.optiondesc)">삭제</button>
          </div>
        </div>
      </div>

      <div class="left-right-container" v-for="(n, index) in data.includes" :key="index">
        <div class="left-right">
          <span class="left"> 이미지 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="img" v-for="(img, index) in n.images" :key="index" />
          </div>

          <div class="left">
            <button @click="addText(n.images)">이미지추가</button>
            <button @click="removeText(n.images)">이미지삭제</button>
          </div>
        </div>
        <div class="left-right">
          <span class="left"> 서브타이틀(우측) </span>
          <b-form-input autocomplete="off" class="right" :value="n.subtitle" />
        </div>
        <div class="left-right">
          <span class="left"> 설명 </span>
          <div class="right">
            <b-form-input autocomplete="off" :value="img" v-for="(img, index) in n.desc" :key="index" />
          </div>
          <div class="left">
            <button @click="addText(n.desc)">텍스트 추가</button>
            <button @click="removeText(n.desc)">텍스트 삭제</button>
          </div>
        </div>
      </div>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">요금</span>
      </div>
      <div class="left-right-container">
        <div class="left-right">
          <span class="left"> 웹 이미지 </span>
          <b-form-input autocomplete="off" class="right" :value="data.priceChart1" />
        </div>
        <div class="left-right">
          <span class="left"> 모바일 이미지 </span>
          <b-form-input autocomplete="off" class="right" :value="data.priceChart2" />
        </div>
      </div>
    </div>

    <div class="top">
      <div>
        <span class="sectionTitle">이용안내</span>
        <button @click="addText(data.membership)">줄 추가</button>
        <button @click="removeText(data.membership)">줄 삭제</button>
      </div>
      <hr />
      <div class="left-right-container">
        <div class="left-right" v-for="(n, index) in data.useGuide" :key="index">
          <span class="left"> </span>
          <b-form-input autocomplete="off" class="right" :value="n" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenItemDetail',
  data() {
    return {
      data: {
        header: {
          url: '/files/Package_titleimage.jpg',
          title: 'Baby-D 태교 패키지',
          desc: '곧 만나게 될 사랑하는 아이와 포도호텔에서 자연을 보고, 느끼고, 교감하는 특별한 시간을 만들어보세요.',
          price: `740,000~`,
          receiptDates1: '2022.02.01 ~ 2022.08.01',
          receiptDates2: '2022.02.01 ~ 2022.08.01',
        },
        notice: [
          '※ 투숙 해당 월 3개월 전, 첫째 날(1일) 예약 OPEN',
          '해당 패키지는 온라인 예약 가능합니다. 멤버십 가입 & 온라인 예약으로 다양한 혜택을 받아보세요.',
        ],
        membership: [
          '※ 멤버십 할인 혜택은 온라인 예약에 한해서만 제공됩니다.(유선으로 예약 시 적용 불가)',
          '',
          '- CLASSIC (무료 멤버십 가입 시 부여) : 1박 당 10,000 원 할인',
          '- PREMIER (온라인 예약 1회 이상 투숙 시 부여) : 1박 당 15,000 원 할인',
        ],
        rooms: [
          {
            images: ['/files/Package_room1.jpg', '/files/Package_room2.jpg'],
            subtitle: '디럭스 (양실 / 한실)',
            desc: [
              '한라산 푸른 숲의 맑은 공기와 그림같은 풍경이 바로 눈앞에 펼쳐지는 ',
              '포도호텔의 아늑한 공간에서 진정한 휴식을 느껴보세요.',
            ],
          },
        ],
        packages: [
          {
            images: ['/files/Package_special1.jpg'],
            subtitle: '건강 주스 (2잔)',
            desc: [
              '신선한 과일로 착즙한 영양가득 생과일 주스를 즐겨보세요.(제주 감귤 / 당근 / 키위 / 토마토 中 택 1)',
              '※ 투숙기간 내 1회 제공됩니다.',
            ],
          },
          {
            images: ['/files/Package_special2.jpg'],
            subtitle: '임산부 전용 바디 필로우 & 태아 심음측정기',
            desc: [
              '산모의 편안한 휴식을 배려한 전용 바디 필로우와 아이와 행복한 순간을 교감할 수 있는 태아 심음 측정기가 객실 내 비치되어 있습니다.',
            ],
          },
          {
            images: ['/files/Package_special3.jpg'],
            subtitle: '태교도서 & CD',
            desc: ['아기에게 감미로운 메시지를 들려줄 수 있는 다양한 태교도서와 음악이 객실 내 준비되어 있습니다.'],
          },
          {
            images: ['/files/Package_special4.jpg'],
            subtitle: 'Special Benefit',
            desc: ['카멜리아 힐 입장권 (2매)', '제주의 자연과 함께하는 태교 산책', '※ 투숙기간 내 1회 제공'],
          },
          {
            images: ['/files/Package_special5.jpg'],
            subtitle: '[2박 투숙 혜택]',
            desc: [
              '포도호텔 레스토랑 Signature Menu 우동 제공 (2인)',
              '(왕새우 튀김우동/왕새우 짬뽕우동/보말우동/한우 스끼야끼 우동 中 택 1)',
              '※ 투숙기간 내 1회 제공',
              '이용시간 12:00 ~ 15:30 (Last order 15:00)',
            ],
          },
        ],
        includes: [
          {
            images: ['/files/Package_basic1.jpg', '/files/Package_basic2.jpg'],
            subtitle: '조식 (2인)',
            desc: [
              '산모와 아이의 건강을 챙겨줄 든든한 아침식사',
              '[메뉴]',
              '한식 3종 or 양식 2종 中 택 1',
              ' ※ 1박 당 1회 제공됩니다.',
            ],
          },
          {
            images: ['/files/Package_basic3.jpg'],
            subtitle: '아라고나이트 온천',
            desc: [
              '객실에서 프라이빗하게 즐기는 아라고나이트 온천으로 자연이 주는 건강한 에너지를 느껴보세요.',
              '한실 : 히노끼 욕조',
              '양실 : 대리석 욕조',
            ],
          },
          {
            images: ['/files/Package_basic4.jpg', '/files/Package_basic5.jpg'],
            subtitle: 'Welcome Gifts',
            desc: [
              '웰컴과일 제공 (투숙기간 내 1회)',
              '미니바 All free (1박당 1회 제공)',
              '  ※ 웰컴과일 및 미니바 구성은 호텔 사정에 따라 달라질 수 있습니다.',
            ],
          },
        ],
        optiondesc: ['※ 옵션은 선택사항이며, 온라인 예약 시 ‘고객 요청란’ 으로 신청해 주시기 바랍니다.'],
        options: [
          {
            images: ['/files/Package_option1.jpg', '/files/Package_option2.jpg', '/files/Package_option3.jpg '],
            subtitle: 'Baby-D 특별 석식 코스',
            desc: [
              '오직 Baby-D 패키지에서만 경험할 수 있는',
              '포도호텔 레스토랑 셰프의 특별 코스 메뉴.',
              '산모를 위해 정성껏 준비한 제주식 로컬 메뉴를 즐겨보시기 바랍니다.',
              '(A코스 / B코스 中 택 1)',
              '\\ 180,000 (2인 1회)',
            ],
          },
          {
            images: ['/files/Package_option4.jpg'],
            subtitle: 'Omorovicza Spa 특별 할인',
            desc: ['휴식에 프리미엄을 더하다’ 전문 스파 테라피스트가 선사하는 스파', '예비 엄마의 피로를 풀어 줄 스파'],
          },
        ],
        priceChart1: '',
        priceChart2: '',
        useGuide: [
          '상기 요금은 2인 1실 1박 기준입니다.(세금포함)',
          '해당 내용은 호텔 사정에 의해 변경될 수 있습니다.',
          '중복 할인은 적용되지 않습니다.',
          '호텔 체크인은 오후 3시, 체크아웃은 오전 11시 입니다.',
          '객실 포함 호텔 내 모든 공간은 금연이며, 반려동물 입장이 금지되어 있습니다.',
          '',
          '취소 위약금 안내',
          '온라인 예약 시, 투숙일 8일 전까지 온라인 취소가 가능하며 그 이후에는 유선 문의 바랍니다.',
          '7일 전~6일 전 30%, 5일 전 50%, 4일 전~2일 전 70%, 2일 전 17시 이후~당일 100% 위약금이 부과됩니다.',
          '',
          '',
          '',
          '문의 및 예약',
          '064)792-8000',
        ],
      },
    };
  },
  methods: {
    addText(list) {
      list.push('');
    },
    removeText(list) {
      list.splice(-1, 1);
    },

    addItem(list) {
      let data = {
        images: [''],
        subtitle: '',
        desc: [''],
      };
      list.push(data);
    },
    removeItem(list) {
      list.splice(-1, 1);
    },
    getData() {
      console.log(JSON.stringify(this.data));
    },
  },
};
</script>

<style scoped>
.top {
  padding-top: 7.5rem;
}

.sectionTitle {
  font-size: 2rem;
}

.left-right-container {
  padding: 2rem;
  border: 1px solid #d3d3d3;
}
.left-right {
  padding: 0.5rem;
  display: flex;
}
.left {
  width: 15%;
}
.right {
  width: 70%;
}
</style>
